/*
 * Created on Thu Oct 12 2023 10:21:38 AM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
import * as types from "../action/types";

const initialState = {
  token: localStorage.getItem("token") || null,
  isAuthenticated: localStorage.getItem("isAuthenticated") ? true : false,
  loading: false,
  isLoggedIn: localStorage.getItem("isLoggedIn") ? true : false,
  alert: false,
  hasFailedLogin: false,
  isLoggingOut: false,
  logoutReason: null,
  // user: JSON.parse(localStorage.getItem("user")) || null,
  applicantData: JSON.parse(localStorage.getItem("applicantData")) || null,

};

const normalizeRoles = (...roleSources) => {
  const roles = roleSources
    .flatMap((source) => {
      if (Array.isArray(source)) return source;
      if (source === undefined || source === null || source === "") return [];
      return [source];
    })
    .map((role) => {
      if (typeof role === "string") return role;
      if (typeof role === "object") return role?.name || role?.value || role?.role || role?.userRole || "";
      return String(role || "");
    })
    .map((role) => String(role || "").trim().toUpperCase().replace(/^ROLE_/, ""))
    .filter(Boolean);

  return [...new Set(roles)];
};

const getPayloadRoles = (payload = {}) => normalizeRoles(
  payload?.userRoles,
  payload?.userRole,
  payload?.roles,
  payload?.authorities,
  payload?.data?.userRoles,
  payload?.data?.userRole,
  payload?.data?.roles,
  payload?.data?.authorities,
  payload?.data?.userDetails?.userRoles,
  payload?.data?.userDetails?.userRole,
  payload?.data?.userDetails?.roles,
  payload?.data?.userDetails?.authorities,
  payload?.userDetails?.userRoles,
  payload?.userDetails?.userRole,
  payload?.userDetails?.roles,
  payload?.userDetails?.authorities
);

const auth = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.REGISTER_SUCCESS:
      return {
        ...state,
        ...payload,
        loading: false,
        isAuthenticated: false,
        isLoggedIn: false, 
        status: false,
        
      };
    case types.SIGNIN_SUCCESS: {
      const payloadRoles = getPayloadRoles(payload);
      const hasMultipleRoles = payloadRoles.length > 1;
      // if (payload.loginStatus === true) {
      //   localStorage.setItem("isAuthenticated", true);
      //   localStorage.setItem("isLoggedIn", true);
      //   localStorage.setItem("user", JSON.stringify(payload));
      //   localStorage.setItem("token", payload.jwtResponse.jwtToken);
      //   localStorage.setItem("email", payload.userDetails.email);
      // }
      return {
        ...state,
        ...payload,
        isAuthenticated: !hasMultipleRoles,
        loading: false,
        isLoggedIn: !hasMultipleRoles,
        isLoggingOut: false,
        loggedOut: false,
        logoutReason: null,
        userRoles: payloadRoles,
        // user: JSON.parse(localStorage.getItem("user")) || null,
      };
    }
    case types.CLEAR_PENDING_AUTH:
      return {
        ...state,
        token: null,
        data: null,
        user: null,
        email: null,
        accessToken: null,
        accessConfirmationToken: null,
        userRoles: [],
        isAuthenticated: false,
        isLoggedIn: false,
        loading: false,
        hasFailedLogin: false,
        isLoggingOut: false,
        logoutReason: null,
        status: false,
        message: null,
      };

    case types.UPDATE_STUDENT:
      if (payload.confirmationToken === "Profile successfully updated") {
        localStorage.setItem("isAuthenticated", true);
        localStorage.setItem("user", JSON.stringify(payload));
      }
      return {
        ...state,
        ...payload,
        loading: false,
        isAuthenticated: true,
        isLoggedIn: true,
      };

    case types.SUBSCRIBED_SUCCESS:
      localStorage.setItem("isAuthenticated", true);
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
        alert: false,
        hasFailedLogin: false,
      };

    case types.PAYMENT_SUCCESS:
      // localStorage.setItem("isAuthenticated", true);
      return {
        ...state,
        ...payload,
        // isAuthenticated: true,
        loading: false,
        hasFailedLogin: false,
      };
    case types.RETURN_URL_SUCCESS:
      // localStorage.setItem("isAuthenticated", true);
      return {
        ...state,
        ...payload,
        // isAuthenticated: true,
        loading: false,
        hasFailedLogin: false,
      };
    // case types.GET_USER_INFO:
    //     localStorage.setItem('isAuthenticated', true);
    //     localStorage.setItem('isLoggedIn', true);
    //     return {
    //         ...state,
    //         ...payload,
    //         isAuthenticated: true,
    //         loading: false,
    //         hasFailedLogin: false
    //     }
    case types.GET_USER_INFO:
      if (payload) {
        localStorage.setItem("isAuthenticated", true);
        localStorage.setItem("userInfo", JSON.stringify(payload));
      }
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
        hasFailedLogin: false,
        userInfo: JSON.parse(localStorage.getItem("userInfo")) || null,
      };
    case types.SEND_PASSWORD_RESET_REQUEST:
      return {
        ...state,
        ...payload,
        isAuthenticated: false,
        loading: false,
        hasFailedLogin: false,
      };
    case types.RESET_PASSWORD:
      return {
        ...state,
        ...payload,
        isAuthenticated: false,
        loading: false,
        hasFailedLogin: false,
      };
    case types.SET_INSTRUCTOR_PASSWORD:
      return {
        ...state,
        ...payload,
        isAuthenticated: false,
        loading: false,
        hasFailedLogin: false,
      };
    case types.REGISTER_FAIL:
      return {
        ...state,
        ...payload,
      };
    case types.SIGNIN_FAIL:
      return {
        ...state,
        ...payload,
      };
    case types.SUBSCRIBED_FAIL:
      return {
        ...state,
        ...payload,
      };
    case types.PAYMENT_FAIL:
      return {
        ...state,
        ...payload,
      };
    case types.UPDATE_STUDENT_FAIL:
      return {
        ...state,
        ...payload,
      };
    case types.GET_USER_EMAIL:
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
        hasFailedLogin: false,
      };
    case types.CONFIRM_USER:
      return {
        ...state,
        ...payload,
        isAuthenticated: false,
        loading: false,
        hasFailedLogin: false,
      };
    case types.CONFIRM_INSTRUCTOR:
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
        hasFailedLogin: false,
      };
    case types.SET_APPLICANT_DATA:
      localStorage.setItem("applicantData", JSON.stringify(payload.applicantData));
      return {
        ...state,
        applicantData: payload.applicantData,
        isAuthenticated: payload.isAuthenticated || state.isAuthenticated,
        loading: false
      };

    case types.FETCH_APPLICANT_SUCCESS:
      return {
        ...state,
        applicantData: payload,
        loading: false
      };

    case types.SET_ADMIN_DATA:
      return {
        ...state,
        adminData: payload.profile,
        userRoles: payload.roles || [],
        isAdmin: true,
        isAuthenticated: true,
        loading: false
      };
    case 'SET_APPLICANT_DATA':
      return {
        ...state,
        applicantData: action.payload.applicantData,
        isAuthenticated: action.payload.isAuthenticated
      };

    case types.LOGOUT_START:
      return {
        ...state,
        isLoggingOut: true,
        logoutReason: action.payload?.reason || null,
      };
    case types.LOGOUT: {
      return {
        token: null,
        data: null,
        user: null,
        userInfo: null,
        adminData: null,
        applicantData: null,
        email: null,
        accessToken: null,
        accessConfirmationToken: null,
        userRoles: [],
        isAuthenticated: false,
        isLoggedIn: false,
        isAdmin: false,
        loading: false,
        alert: false,
        hasFailedLogin: false,
        isLoggingOut: false,
        logoutReason: action.payload?.reason || state.logoutReason || null,
        status: false,
        message: null,
        loggedOut: true,
      };
    }
    default:
      return state;
  }
};
export default auth;
